/**
 * Order Entry - Display State  Enum
 * This enumeration contain identifiers for order state in therms of order entry process.
 * It is used in form-actions and form-notifications panels, so adding a new value here should
 * have corresponding implementation in the actions & notifications components and html.
 */
export enum OENDisplayState {
  SHOW_LOADING,
  SHOW_ORDER_ENTRY,
  SHOW_PROCESSING,
  SHOW_SUCCESS,
  SHOW_MONITOR_EXECUTION,
  SHOW_REJECTED,
  SHOW_APPROVAL_ALLOWED,
  SHOW_APPROVAL_INTERNAL,
  SHOW_APPROVAL_EXTERNAL,
  SHOW_APPROVAL_EXTERNAL_MODIFY,
  SHOW_MODIFY_OUT_ACCEPTANCE,
  SHOW_ACCEPTANCE_ALLOWED,
  SHOW_ACCEPTANCE_CALL,
  SHOW_ACCEPTANCE_EXTERNAL,
  SHOW_ABORTING, // NOT an UI Display state (no changes to notifications or actions), set when abort request issued ,
  SHOW_TOLERANCE,
  SHOW_UNLOCKED,
  SHOW_AMEND_MARKUP,
  SHOW_EXPIRY_PENDING,
  SHOW_LOST_HIDDEN,
  SHOW_NEGATIVE_MARKUP_WARN,
  SHOW_BM_ZERO_AMOUNT_WARN,
}

export namespace OENDisplayState {
  let elements = [
    OENDisplayState.SHOW_LOADING,
    OENDisplayState.SHOW_ORDER_ENTRY,
    OENDisplayState.SHOW_PROCESSING,
    OENDisplayState.SHOW_SUCCESS,
    OENDisplayState.SHOW_MONITOR_EXECUTION,
    OENDisplayState.SHOW_REJECTED,
    OENDisplayState.SHOW_APPROVAL_ALLOWED,
    OENDisplayState.SHOW_APPROVAL_INTERNAL,
    OENDisplayState.SHOW_APPROVAL_EXTERNAL,
    OENDisplayState.SHOW_APPROVAL_EXTERNAL_MODIFY,
    OENDisplayState.SHOW_MODIFY_OUT_ACCEPTANCE,
    OENDisplayState.SHOW_ACCEPTANCE_ALLOWED,
    OENDisplayState.SHOW_ACCEPTANCE_CALL,
    OENDisplayState.SHOW_ACCEPTANCE_EXTERNAL,
    OENDisplayState.SHOW_ABORTING, // NOT an UI Display state (no changes to notifications or actions), set when abort request issued ,
    OENDisplayState.SHOW_TOLERANCE,
    OENDisplayState.SHOW_UNLOCKED,
    OENDisplayState.SHOW_AMEND_MARKUP,
    OENDisplayState.SHOW_EXPIRY_PENDING,
    OENDisplayState.SHOW_LOST_HIDDEN,
    OENDisplayState.SHOW_NEGATIVE_MARKUP_WARN,
    OENDisplayState.SHOW_BM_ZERO_AMOUNT_WARN,
  ];

  export function getAllElements() {
    return elements;
  }
}
